














































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ContentTemplate, ContentTemplateSizesDtoOut } from "@/services/contentTemplates/types";
import { Channel } from "@/services/channels/types";
import { getChannelById } from "@/services/channels/channelsService";
import { getContentTemplatesBySize } from "@/services/contentTemplates/contentTemplateService";
import { TagOption } from "@/services/tags/types";
import { RuntimeTemplateCompiler } from "vue-runtime-template-compiler";

@Component({
    components: {
        RuntimeTemplateCompiler
    }
})
export default class ChannelAddHtmlPostTemplateModal extends Vue {
    @Prop() channelId!: string;
    @Prop({ default: undefined }) propSize!: any;
    @Prop() isEditor!: boolean;
    channel = {} as Channel;
    contentTemplates = [] as ContentTemplate[];
    navigateToCreateItem = false;
    sizes = [] as string[];
    tagOptions = [] as TagOption[];
    searchText = "" as string;
    selectedSize = "";
    cachedSizes = [] as string[];
    loading = true;
    postType = "";

    // computed
    get filteredData() : ContentTemplate[] {
        const dimensions = this.selectedSize.split("x");
        const selectedTags = this.tagOptions.filter(x => x.selected === true);
        return this.contentTemplates
            .filter(ct => ct.width === +dimensions[0] &&
                ct.height === +dimensions[1] &&
                ct.type.toLowerCase() === this.postType.toLowerCase() &&
                (this.searchText === "" ? true : ct.name.toLowerCase().includes(this.searchText.toLowerCase()) || ct.tags.some(y => y.name.toLowerCase().includes(this.searchText.toLowerCase()))) &&
                (selectedTags.length > 0 ? selectedTags.every(x => ct.tags.some(y => y.id === x.id)) : true)
            );
    }

    @Watch("selectedSize") w() {
        if (this.selectedSize === "") return;
        const dimensions = this.selectedSize.split("x");
        if (!this.cachedSizes.includes(this.selectedSize)) {
            this.loading = true;
            getContentTemplatesBySize(+dimensions[0], +dimensions[1]).then(response => {
                this.contentTemplates.push(...response);
                this.cachedSizes.push(this.selectedSize);
                this.loading = false;
                this.initTags();
            });
        }
    }

    initTags() {
        const allTags = this.contentTemplates.flatMap(x => x.tags);
        const uniqueTags = [...new Set(allTags.map(i => JSON.stringify(i)))].map(i => JSON.parse(i));
        const sortedTags = uniqueTags.sort(function (a, b) {
            const textA = a.name.toUpperCase();
            const textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        this.tagOptions = sortedTags.map(x => ({ id: x.id, name: x.name, selected: false } as TagOption));
    }

    // methods
    open(navigationState: boolean, sizes: ContentTemplateSizesDtoOut[], postType = "html") {
        this.searchText = "";
        this.navigateToCreateItem = navigationState;
        this.postType = postType;

        this.sizes = this.sizes.concat(sizes.map(ct => {
            return `${ct.width}x${ct.height}`;
        }));

        this.$nextTick(async () => {
            if (!this.propSize) {
                const channel: Channel = await getChannelById(this.channelId);
                this.selectedSize = `${channel.width}x${channel.height}`;
            } else this.selectedSize = `${this.propSize.width}x${this.propSize.height}`;

            this.sizes.unshift(this.selectedSize);
            this.sizes = [...new Set(this.sizes)];
            this.$bvModal.show("modal-addHtmlPostTemplate");
        });
    }

    selectTemplate(templateId: string) {
        if (this.navigateToCreateItem) {
            if (this.isEditor) {
                this.$router.push({
                    name: "editorCreatePost",
                    params: {
                        channelId: this.channelId,
                        postType: this.postType,
                        contentTemplateId: templateId
                    }
                });
            } else {
                this.$router.push({
                    name: "createPost",
                    params: {
                        channelId: this.channelId,
                        postType: this.postType,
                        contentTemplateId: templateId
                    }
                });
            }
        }
        this.$emit("contentTemplateSelected", templateId);
        this.$bvModal.hide("modal-addHtmlPostTemplate");
    }

    blankPost() {
        this.$router.push({
            name: "createPost",
            params: {
                channelId: this.channelId,
                postType: this.postType
            }
        });
    }

    resetData() {
        this.sizes = [] as string[];
        this.selectedSize = "";
        this.contentTemplates = [] as ContentTemplate[];
        this.cachedSizes = [];
    }
}
